import differenceInYears from './differenceInYears.js';
import { getTzEndOfDay } from './DateUtils24.js';
import { getTzStartOfDay } from './DateUtils11.js';
import { getTzTodayDate } from './DateUtils9.js';

const calculateAge = (birthDateValue) => {
    const endDate = getTzEndOfDay(getTzTodayDate());
    const startDate = getTzStartOfDay(birthDateValue);
    const yearsDifference = differenceInYears(endDate, startDate);
    return yearsDifference;
};

export { calculateAge };
